import { app } from '../../../../app';
import { Controller } from './shared-notes.controller';

app.component('companySharingCenterSharedNotes', {
    bindings: {
        notes: '<',
    },
    controller: Controller,
    templateUrl: require('./shared-notes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/shared-notes.component.js